import React from 'react'

import { Button, useDisclosure } from '@chakra-ui/react'
import { useDispatch } from 'react-redux'

import AgencyModal from './AgencyModal'
import { loadAgencyInstanceData } from '../../../redux/features/agenciesSlice'
import { formatAgencyName } from '../../../utils'

const AgencyButton = ({ agencyName }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const dispatch = useDispatch()
  const handleClick = () => {
    onOpen()
    dispatch(loadAgencyInstanceData({ agency_name: agencyName }))
  }

  return (
    <>
      <Button onClick={handleClick}>{formatAgencyName(agencyName)}</Button>
      <AgencyModal isOpen={isOpen} onClose={onClose} />
    </>
  )
}

export default AgencyButton
